// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SkillAdder.module.scss */
.SkillAdder_skill-adder-container__YBjfy {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 200px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .SkillAdder_skill-adder-container__YBjfy {
    max-width: 100%;
    padding: 10px;
  }
}

.SkillAdder_skill-adder-input__r6FEg {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
}
.SkillAdder_skill-adder-input__r6FEg:focus {
  border-color: #007bff;
}

.SkillAdder_skill-adder-suggestions-container__MkWJE {
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding: 10px;
  background-color: transparent;
  max-width: 200px;
  overflow-wrap: break-word;
  align-items: center;
}
@media (max-width: 768px) {
  .SkillAdder_skill-adder-suggestions-container__MkWJE {
    flex-wrap: wrap;
  }
}

.SkillAdder_skill-adder-suggestions__wZ0fx {
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: nowrap;
  text-wrap: nowrap;
  margin: 0;
  max-width: 100%;
  overflow-x: auto;
}
.SkillAdder_skill-adder-suggestions__wZ0fx li {
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  margin: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: bold;
  background-color: green;
  transform: scale(1); /* Reset the scale */
  animation: SkillAdder_wave-animation__pZHex 2s infinite;
}
.SkillAdder_skill-adder-suggestions__wZ0fx li:hover {
  background-color: #1e7c22;
  transform: scale(1.05);
  animation: none; /* Stop the animation on hover */
}
@media (max-width: 768px) {
  .SkillAdder_skill-adder-suggestions__wZ0fx {
    justify-content: flex-start;
  }
}

@keyframes SkillAdder_wave-animation__pZHex {
  0%, 100% {
    opacity: 0.7;
    transform: translateY(-1px);
  }
  50% {
    opacity: 1;
    transform: translateY(0);
  }
}
.SkillAdder_skill-adder-suggestions__wZ0fx li:nth-child(1) {
  animation-delay: 0.1s;
}

.SkillAdder_skill-adder-suggestions__wZ0fx li:nth-child(2) {
  animation-delay: 0.2s;
}

.SkillAdder_skill-adder-suggestions__wZ0fx li:nth-child(3) {
  animation-delay: 0.3s;
}

.SkillAdder_skill-adder-suggestions__wZ0fx li:nth-child(4) {
  animation-delay: 0.4s;
}

.SkillAdder_skill-adder-suggestions__wZ0fx li:nth-child(5) {
  animation-delay: 0.5s;
}

.SkillAdder_skill-adder-suggestions__wZ0fx li:nth-child(6) {
  animation-delay: 0.6s;
}

.SkillAdder_skill-adder-suggestions__wZ0fx li:nth-child(7) {
  animation-delay: 0.7s;
}

.SkillAdder_skill-adder-suggestions__wZ0fx li:nth-child(8) {
  animation-delay: 0.8s;
}

.SkillAdder_skill-adder-suggestions__wZ0fx li:nth-child(9) {
  animation-delay: 0.9s;
}

.SkillAdder_skill-adder-suggestions__wZ0fx li:nth-child(10) {
  animation-delay: 1s;
}

.SkillAdder_skill-adder-button__NNZCA {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.SkillAdder_skill-adder-button__NNZCA:hover {
  background-color: #0056b3;
}

.SkillAdder_add-icon-container__uBzxi {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Components/SkillAdder/SkillAdder.module.scss"],"names":[],"mappings":"AAAA,2BAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;AAAF;AAEE;EAZF;IAaI,eAAA;IACA,aAAA;EACF;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;AACF;AACE;EACE,qBAAA;AACJ;;AAGA;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAAF;AAEE;EAVF;IAWI,eAAA;EACF;AACF;;AAEA;EACE,gBAAA;EACA,UAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2DAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA,EAAA,oBAAA;EASA,uDAAA;AAPJ;AAAI;EACE,yBAAA;EACA,sBAAA;EACA,eAAA,EAAA,gCAAA;AAEN;AAKE;EAlCF;IAmCI,2BAAA;EAFF;AACF;;AAMA;EACE;IACE,YAAA;IACA,2BAAA;EAHF;EAKA;IACE,UAAA;IACA,wBAAA;EAHF;AACF;AAQE;EACE,qBAAA;AANJ;;AAKE;EACE,qBAAA;AAFJ;;AACE;EACE,qBAAA;AAEJ;;AAHE;EACE,qBAAA;AAMJ;;AAPE;EACE,qBAAA;AAUJ;;AAXE;EACE,qBAAA;AAcJ;;AAfE;EACE,qBAAA;AAkBJ;;AAnBE;EACE,qBAAA;AAsBJ;;AAvBE;EACE,qBAAA;AA0BJ;;AA3BE;EACE,mBAAA;AA8BJ;;AAvBA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;AA0BF;AAxBE;EACE,yBAAA;AA0BJ;;AArBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAwBF","sourcesContent":["/* SkillAdder.module.scss */\n\n.skill-adder-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  max-width: 200px;\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  @media (max-width: 768px) {\n    max-width: 100%;\n    padding: 10px;\n  }\n}\n\n.skill-adder-input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n  outline: none;\n  transition: border-color 0.3s ease;\n\n  &:focus {\n    border-color: #007bff;\n  }\n}\n\n.skill-adder-suggestions-container {\n  display: flex;\n  overflow-x: auto;\n  gap: 10px;\n  padding: 10px;\n  background-color: transparent;\n  max-width: 200px;\n  overflow-wrap: break-word;\n  align-items: center;\n\n  @media (max-width: 768px) {\n    flex-wrap: wrap;\n  }\n}\n\n.skill-adder-suggestions {\n  list-style: none;\n  padding: 0;\n  display: flex;\n  flex-wrap: nowrap;\n  text-wrap: nowrap;\n  margin: 0;\n  max-width: 100%;\n  overflow-x: auto;\n\n  li {\n    padding: 10px;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n    margin: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-weight: bold;\n    background-color: green;\n    transform: scale(1); /* Reset the scale */\n\n    &:hover {\n      background-color: #1e7c22;\n      transform: scale(1.05);\n      animation: none; /* Stop the animation on hover */\n    }\n\n    // Applying wave animation\n    animation: wave-animation 2s infinite;\n  }\n\n  @media (max-width: 768px) {\n    justify-content: flex-start;\n  }\n}\n\n// Define the wave animation\n@keyframes wave-animation {\n  0%, 100% {\n    opacity: 0.7;\n    transform: translateY(-1px);\n  }\n  50% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Apply staggered animation delay to each li element\n@for $i from 1 through 10 {\n  .skill-adder-suggestions li:nth-child(#{$i}) {\n    animation-delay: 0.1s * $i;\n  }\n}\n\n\n\n\n.skill-adder-button {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: #0056b3;\n  }\n}\n\n\n.add-icon-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  margin-bottom: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skill-adder-container": `SkillAdder_skill-adder-container__YBjfy`,
	"skill-adder-input": `SkillAdder_skill-adder-input__r6FEg`,
	"skill-adder-suggestions-container": `SkillAdder_skill-adder-suggestions-container__MkWJE`,
	"skill-adder-suggestions": `SkillAdder_skill-adder-suggestions__wZ0fx`,
	"wave-animation": `SkillAdder_wave-animation__pZHex`,
	"skill-adder-button": `SkillAdder_skill-adder-button__NNZCA`,
	"add-icon-container": `SkillAdder_add-icon-container__uBzxi`
};
export default ___CSS_LOADER_EXPORT___;
